import React, { useContext, useState } from 'react';

import { ArrowLeftCircle, ArrowRightCircle } from '@zooplus/icons';

import CartEventsContext from '../../../common/contexts/CartEventsContext';
import LocResourcesContext from '../../../common/contexts/LocResourcesContext';

import DonationArticle from './DonationArticle';

interface DonationCarouselProps {
  isLoyaltyProgramEnabled: boolean;
}

const DonationCarousel = ({ isLoyaltyProgramEnabled }: DonationCarouselProps): JSX.Element => {
  const GLOBAL_PREFIX: string = 'loy-bp-rws-donations';
  const ARTICLES_PER_PAGE: number = 2;
  const card_articles = React.createRef();
  const { onFormatLocale } = useContext(LocResourcesContext);
  const { donationArticles } = useContext(CartEventsContext);

  const [currentPage, setCurrentPage] = useState<number>(1);

  const previousItems = () => {
    if (currentPage > 1) {
      // @ts-ignore
      card_articles.current.style.transform = `translate(-${660 * (currentPage - ARTICLES_PER_PAGE)}px)`;
      setCurrentPage(currentPage - 1);
    }
  };

  const nextItems = () => {
    // @ts-ignore
    if (currentPage < Math.ceil(card_articles.current.children.length / ARTICLES_PER_PAGE)) {
      // @ts-ignore
      card_articles.current.style.transform = `translate(-${660 * currentPage}px)`;
      setCurrentPage(currentPage + 1);
    }
  };

  return donationArticles && donationArticles.length > 0 ? (
    <React.Fragment>
      <div className={`${GLOBAL_PREFIX}__carousel`}>
        <h2 className={`${GLOBAL_PREFIX}__title`}>
          {onFormatLocale?.('loy.rewards.shop.donate.title')}
        </h2>
        <div
          className={`${GLOBAL_PREFIX}__carousel__button ${GLOBAL_PREFIX}__carousel__button--previous`}
          onClick={() => previousItems()}>
          <a className={`${currentPage === 1 ? `disabled` : `enabled`}`}>
            <ArrowLeftCircle />
          </a>
        </div>

        <div
          className={`${GLOBAL_PREFIX}__carousel__button ${GLOBAL_PREFIX}__carousel__button--next`}
          onClick={() => nextItems()}>
          <a
            className={`${currentPage === Math.ceil(donationArticles.length / ARTICLES_PER_PAGE) ? `disabled` : `enabled`}`}>
            <ArrowRightCircle />
          </a>
        </div>

        <div className={`${GLOBAL_PREFIX}`}>
          <ul // @ts-ignore
            ref={card_articles}
            className={`${GLOBAL_PREFIX}__articles`}>
            {donationArticles.map((article) => {
              return (
                <DonationArticle
                  article={article}
                  quantityInCart={article.quantityInCart ?? 0}
                  isLoyaltyProgramEnabled={isLoyaltyProgramEnabled}
                  key={'carousel-' + article.shopIdentifier}
                />
              );
            })}
          </ul>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <></>
  );
};

export default DonationCarousel;
